import CountrySelect from '@/components/custom-ui/select/CountrySelect';
import {
	FormItem,
	FormMessage,
	FormControl,
	FormLabel,
	FormField,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { useFormContext } from 'react-hook-form';

interface Props {
	selectedCountry: { code: string; dial: string };
	onClick: (val: { code: string; dial: string }) => void;
}

const PhoneNumberField = ({ selectedCountry, onClick }: Props) => {
	const form = useFormContext();

	return (
		<div className="w-full mb-4">
			<FormField
				control={form.control}
				name="phone"
				render={({ field, fieldState }) => (
					<FormItem className="flex flex-col items-start">
						<FormLabel>Phone number</FormLabel>

						<div className="flex flex-wrap w-full gap-2">
							<CountrySelect
								selectedCountry={selectedCountry}
								onClick={onClick}
							/>
							<FormControl>
								<Input
									className={`${fieldState.error && 'border-red'} flex-1`}
									type="tel"
									placeholder="Phone number"
									{...field}
								/>
							</FormControl>
						</div>
						<FormMessage />
					</FormItem>
				)}
			/>
		</div>
	);
};

export default PhoneNumberField;
